export default {
  getReceiving: '/v3/recruit/equipment/payment/detail'
}
